import React, { useContext, useState, useEffect } from 'react';
import { FilterTagStyled, IconClose, Box } from './Styled';
import { context } from '../../../context';
import { withFilters } from '../../../hocs';
import { filterHelp } from '../../../helpers';

interface FilterTagProps {
  rating?: string | null;
  fontSize?: number;
  onClick?: () => void;
  handleFilter: (arg1: any) => void;
  handleFilterType: (arg1: any) => void;
}
// eslint-disable-next-line max-lines-per-function
const Filter: React.FC<FilterTagProps> = (props: FilterTagProps) => {
  const { handleFilter, handleFilterType } = props;
  const { queryParam, dispatchMetrics } = useContext<any>(context);
  const [ratingTag, setRatingTag] = useState<any>(false);
  const [verifiedTag, setVerifiedTag] = useState<any>(false);
  const [skoobTag, setSkoobTag] = useState<any>(false);

  const metricCloseRating = () => {
    handleFilter({ rating: [] });
    dispatchMetrics('event:track', {
      category: 'avaliacao-pdp',
      action: 'fechar-filtro',
    });
  };
  const metricCloseBadges = () => {
    handleFilterType({ badges: null });
    dispatchMetrics('event:track', {
      category: 'avaliacao-pdp',
      action: 'fechar-filtro',
    });
  };
  useEffect(() => {
    if (queryParam?.badges == 'verified_purchaser' || filterHelp(queryParam, 'verified_purchaser')) {
      setVerifiedTag(true);
    } else {
      setVerifiedTag(false);
    }
  }, [queryParam]);
  useEffect(() => {
    if (queryParam?.badges == 'skoob' || filterHelp(queryParam, 'skoob')) {
      setSkoobTag(true);
    } else {
      setSkoobTag(false);
    }
  }, [queryParam]);
  useEffect(() => {
    if (queryParam?.rating?.length) {
      setRatingTag(true);
    } else {
      setRatingTag(false);
    }
  }, [queryParam]);
  const tagSkoob = skoobTag && (
    <FilterTagStyled
      id="skoob"
      width={128}
      fontSize={14}
      onClick={metricCloseBadges}
      className="product-review-filter-tag"
    >
      resenha skoob
      <IconClose className="product-review-filter-tag-close" />
    </FilterTagStyled>
  );

  const tagRating = ratingTag && (
    <FilterTagStyled
      id="rating"
      width={92}
      fontSize={14}
      onClick={metricCloseRating}
      className="product-review-filter-tag"
    >
      {`${queryParam?.rating[0]} estrela${queryParam?.rating[0] == 1 ? '' : 's'}`}
      <IconClose className="product-review-filter-tag-close" />
    </FilterTagStyled>
  );
  const tagVerified = verifiedTag && (
    <FilterTagStyled
      id="verified"
      width={150}
      fontSize={14}
      onClick={metricCloseBadges}
      className="product-review-filter-tag"
    >
      comprou e avaliou
      <IconClose className="product-review-filter-tag-close" />
    </FilterTagStyled>
  );
  return (
    <Box className="product-review-filter-tag-parent">
      {tagRating}
      {tagVerified}
      {tagSkoob}
    </Box>
  );
};

Filter.defaultProps = {
  rating: null,
};
const FilterTag = withFilters(Filter);
export default FilterTag;
export { FilterTag };
